import React from 'react'
import DashboardHeader from './DashboardHeader'
import Sidebar from './Sidebar'
import styled from 'styled-components'

const NGODashboardLayout = ({ children, section, infoText }) => {
  return (
    <div className='relative flex w-full h-screen'>
      <Sidebar />
      <div className='relative w-full h-full flex flex-col overflow-hidden'>
        <DashboardHeader section={section} infoText={infoText} />
        <DashboardContent>{children}</DashboardContent>
      </div>
    </div>
  )
}

export default NGODashboardLayout

const DashboardContent = styled.div`
  flex: 1;
  overflow-y: scroll;
  height: 100%;
  padding: 32px;
  @media only screen and (max-width: 768px) {
      padding: 16px;
    }
  background-color: #EEEEEE;
  .profile-tab {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    background-color: red;
  }
`;